export default __webpack_public_path__ + "static/media/netcos.940229ae.gif";